import { defineStore } from 'pinia'
import { AjaxAuthService, makeOrderService } from '@/service/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
    userInfo: {} as any,
    isLoggedIn: false,
    isMaster: false,
    expressList: [],
    expressId: ''
  }),
  getters: {
    isMaster(state) {
      return state.userInfo.staffType?.id === 'WEBMASTER'
    },
    getExpressId: (state) => state.expressId,
    // 站点类型 'MAIL' | 'DELIVERY' | 'MAIL_DELIVERY' | 'JT_POINT'
    getStationType: (state) => state.userInfo.stationType?.id || ''
  },
  actions: {
    //登录
    login(params: any) {
      return new Promise((resolve, reject) => {
        AjaxAuthService.login(params)
          .then((res) => {
            if (res.code === 1) {
              this.userInfo = res.data
              this.token = res.data.token
              this.isLoggedIn = true
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    //退出登录
    logOut() {
      return new Promise((resolve, reject) => {
        AjaxAuthService.logOut()
          .then((res) => {
            if (res.code === 1) {
              this.token = ''
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    
    /**
     * 获取快递公司列表
     */
    getExpressList() {
      return new Promise((resolve, reject) => {
        makeOrderService.expressList({}).then((res) => {
          if (res.code === 1) {
            console.log('this.expressId', res.data)
            this.expressList = res.data
            const expressObj = res.data.find((_: { value: string }) => {
              return (_.value === 'JT_EXPRESS')
            })
            this.expressId = expressObj.key
            console.log('this.expressId', expressObj, this.expressId)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    initExpressId() {
      return new Promise((resolve, reject) => {
        if (this.expressId) {
          resolve(this.expressId)
        } else {
          this.getExpressList().then(() => resolve(this.expressId)).catch((err) => reject(err))
        }
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
